// extracted by mini-css-extract-plugin
export default {"productGallery":"GN-z","inQuickShop":"HN-z"};